import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { logError } from 'reporting-data/monitoring/logger';
import { getCurrencyInfo } from '../../../api/multiCurrency';
async function fetchCurrencyInfo() {
  try {
    return await getCurrencyInfo();
  } catch (error) {
    logError({
      error
    });
    throw error;
  }
}
export function useFetchMultiCurrencyInfo() {
  return useAsyncFetcher({
    fetcher: fetchCurrencyInfo
  });
}